<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Merge Review Package
    <span class="mc-fill-remaining-flex-space"></span>
    <button mat-icon-button color="secondary-invert" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-body">
    <p>Applying changes in progress</p>

    <mat-progress-bar class="mc-review-package-workspace-merge-progress-dialog-progress-bar" mode="determinate" color="notice" [value]="progressPercent$ | async"></mat-progress-bar>

    <mat-accordion *ngIf="reviewPackageFiles?.length" class="accordion-flat mc-accordion-list" displayMode="flat" togglePosition="before">
      <mat-expansion-panel class="mc-review-package-workspace-merge-progress-dialog-files" [expanded]="true">
        <mat-expansion-panel-header class="mc-review-package-workspace-merge-progress-dialog-files-header" collapsedHeight="3rem" expandedHeight="3rem">
          <mat-panel-title>
            {{reviewPackageFiles.length}} {{reviewPackageFiles.length > 1 ? 'Files' : 'File'}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li *ngFor="let file of reviewPackageFiles">{{file.Name}}</li>
        </ul>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="mc-spring-board-footer">
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button (click)="closeDialog()" color="primary">Close</button>
  </div>
</div>